const angular = require('angular');

const MultiFactorAuthenticationService = require('./multi-factor-authentication.service');


angular.module('wowApp.common')
    .service('MultiFactorAuthenticationService', ['Settings', 'RestangularV3', MultiFactorAuthenticationService]);



// WEBPACK FOOTER //
// ./src/common/multi-factor-authentication/index.js